/* This page is for Approval and Display page */

import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
// import { formatDateTime } from "../../../common/Validations";
import ShowHorizontalStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowHorizontalStatus";
import Loader from "../../../../Components/Loader";
import EvaluationTable from "../../../../Components/PivotTable/EvaluationTable";
import TechLineItemTable from "../../../../Components/PivotTable/TechLineItemTable";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import { getRfqQuotation } from "../../../../redux/feature/supplier_app/sourcingSlice";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { formatDateTime, getCurrentDate } from "../../../../common/Validations";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import WorkflowApproveReject from "../../../../Components/Workflow/WorkflowApproveReject";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { MultiselectField } from "../../../../Components/formElements/MultiselectField";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const TechnicalEvaluation = () => {
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");

  let rfxNr = useSelector((state) => state?.sourcing?.rfq?.rfxNr); // User Details from Store
  let workflowConfig = useSelector((state) => state?.common?.data?.workflow); // workflowConfig Details from Store
  let sourcingConfig = useSelector((state) => state?.common?.data?.sourcing); // Common Details from Store
  let workflow = useSelector((state) => state?.sourcing?.rfq?.workflowTECH); // workflowTECH from Store
  let userData = useSelector((state) => state?.sourcing?.rfq?.data); // User Details from Store
  const [matchObj, setMatchObje] = useState([]);
  useEffect(() => {
    const matchedObject = userData.find((item) => item.rfxNr === rfxNr);
    setMatchObje(matchedObject);
    // eslint-disable-next-line
  }, [rfxNr]);

  const modalData = {
    title: "Technical Evaluation",
    successMsg: "",
  };

  const [loading, setLoading] = useState(true);
  const [techData, setTechData] = useState([]);
  const [getTechnicalEvalHeaderData, setTechnicalEvalHeaderData] = useState([]);
  const [lineItemData, setLineItemData] = useState([]);
  const [technicalEvaluationTableData, setTechnicalEvaluationTableData] =
    useState([]);
  const [itemTableData, setItemTableData] = useState([]);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getTechnicalUserList, setTechnicalUserList] = useState([]);
  const [getDropdownData, setDropdownData] = useState("");
  const [getDisabledStatus, setDisabledStatus] = useState(false);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);

  const [formInputs, setFormInputs] = useState({
    rfxType: "",
    productType: "",
    rfxValue: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    buyerResponsible: "",
    companyAddress: "",
    rfxVersion: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    billingAddressCodeDesc: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCategoryCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxTitle: "",
    openingdate: "",
    openingtime: "",
    closingdate: "",
    closingtime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    items: "",
    formCOMM: "",
    formTECH: "",
    termsConditions: [],
    supplierList: [],

    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
    techEvaluationStartedOn: "",
    techEvaluationPreparedOn: "",
    technicalEvaluator: "",
  });

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // Function to handle text changes
  const handleInputChangeTable = (id, value) => {
    const updatedData = formInputs?.supplierList?.map((item) => {
      return item.AssociateNumber === id
        ? {
            ...item,
            qtnSupplierRemarks: value,
          }
        : item;
    });

    setFormInputs((prevState) => ({
      ...prevState, // Keep the other fields in formInputs unchanged
      supplierList: updatedData, // Update the supplierList field
    }));
  };

  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.AssociateNumber || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },

    {
      name: "Supplier",
      selector: (row) => row.organisationName,
      sortable: true,
      cell: (row) => <>{row.organisationName}</>,
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.quotationNr || "-"}{" "}
        </button>
      ),
      width: "140px",
    },
    {
      name: "Quotation Date",
      selector: (row) => formatDateTime(row?.quotationCreatedAt) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Quotation Version",
      selector: (row) => row?.qtnVersion || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      selector: (row) => row.qtnSupplierStatus || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Remarks",
      selector: (row) => row.qtnSupplierRemarks,
      cell: (row) => (
        <>
          {getDisabledStatus ? (
            row?.qtnSupplierRemarks
          ) : (
            <InputField
              className="inputBox mt-1"
              name="qtnSupplierRemarks"
              value={row.qtnSupplierRemarks}
              onChange={(e) =>
                handleInputChangeTable(row.AssociateNumber, e.target.value)
              }
              disabled={getDisabledStatus}
            />
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
  ];

  const loadGetInfo = async () => {
    let obj = {
      queryName: "getRFXTechEvaluationDetail",
      documentNumber: rfxNr,
    };
    // console.log(">>obj", obj)
    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        setTechnicalEvalHeaderData(item?.data[0]);
        setTimeout(() => {
          // console.log(">> setTechData", item?.data);
          setTechData(item?.data);
          setLineItemData(item?.data);
        }, 1000);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };
  // Load data
  const loadTechnicalEvaluationData = async () => {
    if (rfxNr) {
      let obj = {
        queryName: "ShowRFXTechEvaluation",
        rfxNr: rfxNr,
      };
      // console.log(">>>obj1", obj)
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.generateQuery(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setFormInputs(item.data[0]);
          if (
            item?.data[0]?.rfxHeaderStatus === "Tech Approved" ||
            item?.data[0]?.rfxHeaderStatus === "Commercial Open" ||
            item?.data[0]?.rfxHeaderStatus === "Commercial Approved" ||
            item?.data[0]?.rfxHeaderStatus === "Commercial Pending with L1" ||
            item?.data[0]?.rfxHeaderStatus === "Commercial Pending with L2"
          ) {
            setDisabledStatus(true);
            loadGetInfo();
          } else {
            setDisabledStatus(false);
            setTechnicalEvalHeaderData(item?.data[0]);
            setTimeout(() => {
              setTechData(item?.data);
              setLineItemData(item?.data);
            }, 1000);
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      setLoading(false);
    } else {
      window.history.back();
    }
  };

  // From Child Component
  const handleEvaluationTableData = (data) => {
    // console.log(">> child tech ", data);
    setTechnicalEvaluationTableData(data);
    setFormInputs((formInputs) => ({
      ...formInputs,
      rfxQuestions: data,
    }));
  };

  // From Child Component
  const handleItemData = (data) => {
    // console.log(">> item tech ", data);
    setItemTableData(data);
    setFormInputs((formInputs) => ({
      ...formInputs,
      items: data,
    }));
  };

  useEffect(() => {
    // loadInitialPageData();
    loadTechnicalEvaluationData();
    loadTechUser();
    formInputs.techEvaluationStartedOn = getCurrentDate("");
    formInputs.techEvaluationPreparedOn = getCurrentDate("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  const loadTechUser = async () => {
    let obj = {
      roleId: "TECHNICAL",
    };
    await ItemService.getTechnicalUser(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalUserList(item?.data);
      } else {
        setTechnicalUserList([]);
        console.log(">> Error: Loading loadTechUser");
      }
    });
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">>datarfq", getDropdownData);
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // SAVE
  // eslint-disable-next-line no-unused-vars
  const handleSave = async () => {
    // let requiredFields = [];

    // if(!validateRequired(formInputs?.organisationName)) {
    //   requiredFields.push('*Please enter Supplier Name');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!validateEmail(formInputs?.email)) {
    //   requiredFields.push('*Invalid Contact Email address');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!getPOLineItemsData[0]?.materialCode) {
    //   toast.error("Alteast one PO Line item should be added.", {
    //     duration: 4000,
    //     position: "top-right",
    //   });
    //   return;
    // }

    formInputs.rfxQuestions = technicalEvaluationTableData;
    formInputs.items = itemTableData;

    // console.log(">> handleSave", formInputs);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };

    await ItemService.addRfxTechEvaluation(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        // Update response value in Redux Store
        dispatch(getRfqQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
  };

  const handleEditorChange = (content) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      instructions: content,
    }));
  };

  const formattedDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return ""; // prevent invalid date issues
    return d.toISOString().split("T")[0]; // returns YYYY-MM-DD
  };

  const handleExportTechEvalQuestions = () => {
    const questions = formInputs?.rfxQuestions || [];
    if (!questions?.length) {
      toast.error("No evaluation questions data available");
      return;
    }
    const suppliers = questions[0]?.quotationDocument || [];

    // Calculate total score per supplier and sort descending (highest score first)
    const scoreBySupplier = {};
    questions.forEach((q) => {
      (q.quotationDocument || []).forEach((d) => {
        const nr = d.quotationNr;
        scoreBySupplier[nr] = (scoreBySupplier[nr] || 0) + Number(d.score || 0);
      });
    });

    const sortedSuppliers = [...suppliers].sort((a, b) => {
      return (
        (scoreBySupplier[b.quotationNr] || 0) -
        (scoreBySupplier[a.quotationNr] || 0)
      );
    });

    // Row 1: merged supplier header (4 empty cols, then each supplier spans 3 cols)
    const headerRow1 = [
      "",
      "",
      "",
      "",
      ...sortedSuppliers.flatMap((s, i) => [
        `${s.organisationName} - ${s.quotationNr} (L${i + 1})`,
        "",
        "",
      ]),
    ];

    // Row 2: column sub-headers
    const headerRow2 = [
      "Sl No",
      "Questionaries",
      "Criteria",
      "Weightage",
      ...sortedSuppliers.flatMap(() => [
        "Supplier Response",
        "Score",
        "Comments",
      ]),
    ];

    // Data rows
    const dataRows = questions.map((q) => {
      const row = [
        q.serialNo,
        q.question?.label || "",
        q.criteria || "",
        q.weightage || 0,
      ];
      sortedSuppliers.forEach((s) => {
        const doc = q.quotationDocument?.find(
          (d) => d.quotationNr === s.quotationNr,
        );
        const formResponse = doc
          ? (doc.formTECH || doc.formCOMM || []).find(
              (f) => f.question_no === q.componentId,
            )
          : null;
        row.push(formResponse?.question_value || "--");
        row.push(doc?.score || 0);
        row.push(doc?.comments || "");
      });
      return row;
    });

    // Total footer row
    const totalWeightage = questions.reduce(
      (sum, q) => sum + Number(q.weightage || 0),
      0,
    );
    const totalRow = ["", "Total", "", totalWeightage];
    sortedSuppliers.forEach((s) => {
      totalRow.push("", scoreBySupplier[s.quotationNr] || 0, "");
    });

    const allRows = [headerRow1, headerRow2, ...dataRows, totalRow];
    const ws = XLSX.utils.aoa_to_sheet(allRows);

    // Merge supplier cells in header row 1 (row 0)
    ws["!merges"] = sortedSuppliers.map((_, i) => {
      const startCol = 4 + i * 3;
      return {
        s: { r: 0, c: startCol },
        e: { r: 0, c: startCol + 2 },
      };
    });

    ws["!cols"] = allRows[0].map((_, i) => ({
      wch: Math.max(...allRows.map((r) => String(r[i] || "").length)),
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `Tech_Eval_Questions_${rfxNr}.xlsx`);
  };

  const handleExportTechLineItems = () => {
    const items = itemTableData?.length
      ? itemTableData
      : formInputs?.items || [];
    if (!items?.length) {
      toast.error("No line item data available");
      return;
    }
    const suppliers = items[0]?.quotationDocument || [];

    // Calculate total price per supplier (sum of qtnitemValue) and sort ascending (lowest first)
    const totalBySupplier = {};
    items.forEach((item) => {
      (item.quotationDocument || []).forEach((d) => {
        const nr = d.quotationNr;
        totalBySupplier[nr] =
          (totalBySupplier[nr] || 0) + Number(d.qtnitemValue || 0);
      });
    });

    const sortedSuppliers = [...suppliers].sort((a, b) => {
      return (
        (totalBySupplier[a.quotationNr] || 0) -
        (totalBySupplier[b.quotationNr] || 0)
      );
    });

    // Row 1: merged supplier header (6 empty cols, then each supplier spans 2 cols)
    const headerRow1 = [
      "",
      "",
      "",
      "",
      "",
      "",
      ...sortedSuppliers.flatMap((s, i) => [
        `${s.organisationName} - ${s.quotationNr} (L${i + 1})`,
        "",
      ]),
    ];

    // Row 2: column headers matching TechLineItemTable UI
    const headerRow2 = [
      "SL No",
      "Purchase Document",
      "Status",
      "Material Code",
      "Qty",
      "Unit",
      ...sortedSuppliers.flatMap(() => ["Approve/Reject", "Comments"]),
    ];

    // Data rows
    const dataRows = items.map((item) => {
      const row = [
        item.rfxItemNr || item.local_id,
        item.purchaseReqDocumentNr || "",
        item.prStatusItem || "-",
        `${item.materialCode || ""} - ${item.materialDescription || ""}`,
        item.purchaseQuantity || "",
        item.orderUnitOfMeasure || "",
      ];
      sortedSuppliers.forEach((s) => {
        const doc = item.quotationDocument?.find(
          (d) => d.quotationNr === s.quotationNr,
        );
        row.push(doc?.approveReject || "-");
        row.push(doc?.comments || "");
      });
      return row;
    });

    const allRows = [headerRow1, headerRow2, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(allRows);

    // Merge supplier cells in header row 1 (row 0)
    ws["!merges"] = sortedSuppliers.map((_, i) => {
      const startCol = 6 + i * 2;
      return {
        s: { r: 0, c: startCol },
        e: { r: 0, c: startCol + 1 },
      };
    });

    ws["!cols"] = allRows[0].map((_, i) => ({
      wch: Math.max(...allRows.map((r) => String(r[i] || "").length)),
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `Tech_Line_Items_${rfxNr}.xlsx`);
  };

  const handleExportTechSuppliers = () => {
    const data = getTechnicalEvalHeaderData?.supplierList;
    if (!data?.length) {
      toast.error("No supplier data available");
      return;
    }
    const rows = data.map((row) => [
      row.AssociateNumber || "--",
      row.status || "--",
      row.organisationName || "--",
      row.sapAssociateNumber || "--",
      row.quotationNr || "--",
      formatDateTime(row?.quotationCreatedAt) || "--",
      row?.qtnVersion || "--",
      row.qtnSupplierStatus || "--",
      row.qtnSupplierRemarks || "",
    ]);
    const headerRow = [
      "Supplier ID",
      "Status",
      "Supplier",
      "SAP Number",
      "Quotation Nr",
      "Quotation Date",
      "Quotation Version",
      "Status",
      "Remarks",
    ];
    const ws = XLSX.utils.aoa_to_sheet([headerRow, ...rows]);
    ws["!cols"] = headerRow.map((_, i) => ({
      wch: Math.max(
        ...rows.map((r) => String(r[i] || "").length),
        headerRow[i].length,
      ),
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `Tech_Eval_Suppliers_${rfxNr}.xlsx`);
  };

  const handleExportTechAll = async () => {
    const hasAnyData =
      getTechnicalEvalHeaderData?.supplierList?.length ||
      formInputs?.rfxQuestions?.length ||
      itemTableData?.length;
    if (!hasAnyData) {
      toast.error("No data available to export");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("All Data");
    let rowIdx = 1;

    const addSectionTitle = (title, colCount) => {
      if (colCount > 1) worksheet.mergeCells(rowIdx, 1, rowIdx, colCount);
      const cell = worksheet.getCell(rowIdx, 1);
      cell.value = title;
      cell.font = { bold: true, size: 14 };
      rowIdx++;
    };

    const addHeaders = (headers) => {
      headers.forEach((h, i) => {
        const cell = worksheet.getCell(rowIdx, i + 1);
        cell.value = h;
        cell.font = { bold: true };
      });
      rowIdx++;
    };

    const addDataRow = (dataObj, columns) => {
      columns.forEach((col, i) => {
        try {
          worksheet.getCell(rowIdx, i + 1).value =
            typeof col.selector === "function"
              ? col.selector(dataObj)
              : (dataObj[col.id] ?? "");
        } catch {
          worksheet.getCell(rowIdx, i + 1).value = "";
        }
      });
      rowIdx++;
    };

    // 1. Selected Suppliers Details
    const supplierList = getTechnicalEvalHeaderData?.supplierList;
    if (supplierList?.length) {
      const supHeaders = suppliersColumns.map((c) => c.name);
      addSectionTitle("Selected Suppliers Details", supHeaders.length);
      addHeaders(supHeaders);
      supplierList.forEach((r) => addDataRow(r, suppliersColumns));
      rowIdx++;
    }

    // 2. Technical Evaluation Questions
    const questions = formInputs?.rfxQuestions;
    if (questions?.length) {
      const suppliers = questions[0]?.quotationDocument || [];
      const scoreBySupplier = {};
      questions.forEach((q) => {
        (q.quotationDocument || []).forEach((d) => {
          scoreBySupplier[d.quotationNr] =
            (scoreBySupplier[d.quotationNr] || 0) + Number(d.score || 0);
        });
      });
      const sortedSuppliers = [...suppliers].sort(
        (a, b) =>
          (scoreBySupplier[b.quotationNr] || 0) -
          (scoreBySupplier[a.quotationNr] || 0),
      );
      const qHeaders = [
        "Sl No",
        "Questionaries",
        "Criteria",
        "Weightage",
        ...sortedSuppliers.flatMap((s, i) => [
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Supplier Response`,
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Score`,
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Comments`,
        ]),
      ];
      addSectionTitle("Technical Evaluation Questions", qHeaders.length);
      addHeaders(qHeaders);

      // Bold the L1 supplier's columns (cols 5,6,7 in 1-indexed)
      const boldL1Cols = sortedSuppliers.length > 0;

      questions.forEach((q) => {
        const row = [
          q.serialNo,
          q.question?.label || "",
          q.criteria || "",
          q.weightage || 0,
        ];
        sortedSuppliers.forEach((s) => {
          const doc = q.quotationDocument?.find(
            (d) => d.quotationNr === s.quotationNr,
          );
          const formResponse = doc
            ? (doc.formTECH || doc.formCOMM || []).find(
                (f) => f.question_no === q.componentId,
              )
            : null;
          row.push(formResponse?.question_value || "--");
          row.push(doc?.score || 0);
          row.push(doc?.comments || "");
        });
        row.forEach((val, i) => {
          const cell = worksheet.getCell(rowIdx, i + 1);
          cell.value = val;
          // Bold L1 columns (indices 4,5,6 → 1-indexed: 5,6,7)
          if (boldL1Cols && i >= 4 && i <= 6) {
            cell.font = { bold: true };
          }
        });
        rowIdx++;
      });

      // Also bold the L1 header cells
      if (boldL1Cols) {
        for (let c = 5; c <= 7; c++) {
          const headerCell = worksheet.getCell(1, c);
          if (headerCell.value) headerCell.font = { bold: true };
        }
        // Find the section header row for Technical Evaluation Questions
        // and bold it too - it's at rowIdx - dataRows.length - 2
      }

      rowIdx++;
    }

    // 3. Commercial Evaluation Questions
    const commQuestions = formInputs?.rfxQuestions;
    if (commQuestions?.length) {
      const commSuppliers = commQuestions[0]?.quotationDocument || [];
      const commScoreBySupplier = {};
      commQuestions.forEach((q) => {
        (q.quotationDocument || []).forEach((d) => {
          commScoreBySupplier[d.quotationNr] =
            (commScoreBySupplier[d.quotationNr] || 0) + Number(d.score || 0);
        });
      });
      const commSortedSuppliers = [...commSuppliers].sort(
        (a, b) =>
          (commScoreBySupplier[b.quotationNr] || 0) -
          (commScoreBySupplier[a.quotationNr] || 0),
      );
      const commQHeaders = [
        "Sl No",
        "Questionaries",
        "Criteria",
        "Weightage",
        ...commSortedSuppliers.flatMap((s, i) => [
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Supplier Response`,
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Score`,
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Comments`,
        ]),
      ];
      addSectionTitle("Commercial Evaluation Questions", commQHeaders.length);
      addHeaders(commQHeaders);
      commQuestions.forEach((q) => {
        const row = [
          q.serialNo,
          q.question?.label || "",
          q.criteria || "",
          q.weightage || 0,
        ];
        commSortedSuppliers.forEach((s) => {
          const doc = q.quotationDocument?.find(
            (d) => d.quotationNr === s.quotationNr,
          );
          const formResponse = doc
            ? (doc.formCOMM || []).find((f) => f.question_no === q.componentId)
            : null;
          row.push(formResponse?.question_value || "--");
          row.push(doc?.score || 0);
          row.push(doc?.comments || "");
        });
        row.forEach((val, i) => {
          worksheet.getCell(rowIdx, i + 1).value = val;
        });
        rowIdx++;
      });
      rowIdx++;
    }

    // 4. Line Item
    const items = itemTableData?.length ? itemTableData : formInputs?.items;
    if (items?.length) {
      const suppliers = items[0]?.quotationDocument || [];
      const totalBySupplier = {};
      items.forEach((item) => {
        (item.quotationDocument || []).forEach((d) => {
          totalBySupplier[d.quotationNr] =
            (totalBySupplier[d.quotationNr] || 0) + Number(d.qtnitemValue || 0);
        });
      });
      const sortedSuppliers = [...suppliers].sort(
        (a, b) =>
          (totalBySupplier[a.quotationNr] || 0) -
          (totalBySupplier[b.quotationNr] || 0),
      );
      const liHeaders = [
        "SL No",
        "Purchase Document",
        "Status",
        "Material Code",
        "Qty",
        "Unit",
        ...sortedSuppliers.flatMap((s, i) => [
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Approve/Reject`,
          `${s.organisationName} - ${s.quotationNr} (L${i + 1}) - Comments`,
        ]),
      ];
      addSectionTitle("Line Item", liHeaders.length);
      addHeaders(liHeaders);
      items.forEach((item) => {
        const row = [
          item.rfxItemNr || item.local_id,
          item.purchaseReqDocumentNr || "",
          item.prStatusItem || item.statusItem || "-",
          `${item.materialCode || ""} - ${item.materialDescription || ""}`,
          item.purchaseQuantity || "",
          item.orderUnitOfMeasure || "",
        ];
        sortedSuppliers.forEach((s) => {
          const doc = item.quotationDocument?.find(
            (d) => d.quotationNr === s.quotationNr,
          );
          row.push(doc?.approveReject || "-");
          row.push(doc?.comments || "");
        });
        row.forEach((val, i) => {
          worksheet.getCell(rowIdx, i + 1).value = val;
        });
        rowIdx++;
      });
      rowIdx++;
    }

    // Auto-fit column widths
    worksheet.columns.forEach((col) => {
      if (col && col.values) {
        let maxLen = 0;
        col.values.forEach((v) => {
          const len = String(v ?? "").length;
          if (len > maxLen) maxLen = len;
        });
        col.width = Math.min(maxLen + 3, 60);
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Tech_All_Data_${rfxNr}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <Loader isLoading={loading} className={"text-center"} />
        </Col>
        {!loading && (
          <Col xs={12} md={12} className="rightSide">
            <div className="rightSideInner PageCommonCSS">
              <h2 className="mainTitle">
                Technical Evaluation for
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {formInputs?.rfxNr}
                </span>
                <span>
                  {formInputs?.rfxHeaderStatus === "Published" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "QTN Received" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus ===
                    "Commercial Pending with L1" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus ===
                    "Commercial Pending with L2" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Cancelled" ? (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "RFQ Created" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Acknowledged" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Commercial Approved" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Tech Approved" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Technical Open" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Commercial Open" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : (
                    formInputs?.rfxHeaderStatus
                  )}
                </span>
              </h2>
              <p className="subText">Technical Evaluation Details</p>
              <hr />

              {/* Workflow Component */}
              <WorkflowApproveReject
                workflowData={workflow}
                formInputsData={formInputs}
              />

              {workflowConfig?.showInDetailPage &&
                formInputs?.workflowActionLogs?.length > 0 && (
                  <ShowHorizontalStatus
                    rowdatamodal={formInputs?.workflowActionLogs}
                  />
                )}

              {/*RFQ Type  */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RT</span>
                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <span className="headerTitle">RFQ Details </span>
                        <span className="subHeaderTitle">
                          RFQ Type Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ ID"
                            name="rfxNr"
                            // placeholder=""
                            value={formInputs?.rfxNr || ""}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Version"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.rfxVersion || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Title"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxTitle || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxDescription || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Category"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxCategoryDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Type"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Number Of Evaluation"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxNoOfEvaluationTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Product Type"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.productTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Contact"
                            name="buyerConact"
                            // placeholder=""
                            value={matchObj?.buyerConact || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Responsible"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.initiatorName || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Billing Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.billingAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Address"
                            name="companyAddress"
                            placeholder=""
                            value={formInputs?.companyAddress || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.billingAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          {/* <InputField
                            className="inputBox"
                            label="INCOTerms"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.INCOTermslocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          /> */}
                          {matchObj?.incoTerms && (
                            <MultiselectField
                              label="INCO Terms"
                              placeholder="Please select the INCO Terms"
                              // data={getINCOTerms}
                              id="INCOTerms"
                              iconClassName="dropdownIcon"
                              name="INCOTerms"
                              setValue={matchObj?.incoTerms ? [matchObj?.incoTerms] : []}
                              // getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={true}
                            />
                          )}
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms Location"
                            name="incoTermsLocation"
                            placeholder=""
                            value={matchObj?.incoTermsLocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {/*Header Info */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible3
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">HI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          Technical Evaluation Details
                        </span>
                        <span className="subHeaderTitle">
                          Technical Evaluation Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible3 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tech Evaluation Started On"
                            type="date"
                            name="techEvaluationStartedOn"
                            value={formattedDate(
                              formInputs?.techEvaluationStartedOn ||
                                getTechnicalEvalHeaderData?.techEvaluationStartedOn ||
                                getCurrentDate(""),
                            )}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tech Evaluation Prepared On"
                            name="techEvaluationPreparedOn"
                            type="date"
                            value={formattedDate(
                              formInputs?.techEvaluationPreparedOn ||
                                getTechnicalEvalHeaderData?.techEvaluationPreparedOn ||
                                getCurrentDate(""),
                            )}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Tech Focal Point"
                            placeholder=""
                            data={getTechnicalUserList}
                            id="rfxTechFocalPersonId"
                            name="rfxTechFocalPersonId"
                            code="rfxTechFocalPersonIdCode"
                            description="rfxTechFocalPersonIdDesc"
                            iconClassName="dropdownIcon"
                            setValue={
                              formInputs?.rfxTechFocalPersonId ||
                              getTechnicalEvalHeaderData?.rfxTechFocalPersonId
                            }
                            getvalue={setDropdownData}
                            disabled={getDisabledStatus}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label=" Technical Approval Type"
                            name="firstName"
                            placeholder=""
                            value={
                              formInputs?.technicalApprovalType ||
                              getTechnicalEvalHeaderData?.technicalApprovalType
                            }
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Eligibility Score"
                            name="firstName"
                            placeholder=""
                            value={
                              sourcingConfig?.rfxControlData?.eligibilityScore
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Technical Evaluator"
                            name="technicalEvaluator"
                            placeholder=""
                            value={
                              formInputs?.technicalEvaluator ||
                              getTechnicalEvalHeaderData?.technicalEvaluator
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Evaluator Comments"
                            name="evaluatorComments"
                            value={
                              formInputs?.evaluatorComments ||
                              getTechnicalEvalHeaderData?.evaluatorComments
                            }
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Evaluator Supplier Clarification"
                            name="evaluatorSupplierClarification"
                            value={
                              formInputs?.evaluatorSupplierClarification ||
                              getTechnicalEvalHeaderData?.evaluatorSupplierClarification
                            }
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Upload Tech Eval Report Attachments"
                            name="uploadTechEvalReportAttachments"
                            value={
                              formInputs?.uploadTechEvalReportAttachments ||
                              getTechnicalEvalHeaderData?.uploadTechEvalReportAttachments
                            }
                            // value={formInputs?.uploadTechEvalReportAttachments}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                          <div className="col-sm-10">
                            <input
                              className="form-control"
                              type="file"
                              id="formFile"
                              disabled={getDisabledStatus}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Instructions 10*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible10
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility10}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RE</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Instructions</span>
                        <span className="subHeaderTitle">
                          Instructions Section
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible10 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="p-4">
                        <Col xs={12} md={12} lg={12}>
                          <RichTextEditor
                            value={getTechnicalEvalHeaderData?.instructions}
                            readOnly={getDisabledStatus}
                            onChange={handleEditorChange}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* 5 */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible5
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility5}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">SD</span>
                      </Col>
                      <Col xs={11} md={5} lg={6}>
                        <span className="headerTitle">Suppliers</span>
                        <span className="subHeaderTitle">
                          Selected Suppliers Details
                        </span>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-end">
                        <div className="filter">
                          <span
                            className="icon hide headerIcon"
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                          >
                            <i className="bi bi-three-dots"></i>
                          </span>
                          <ul
                            className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                            data-popper-placement="bottom-end"
                          >
                            <li className="dropdown-header text-start">
                              <h6>Menu</h6>
                            </li>

                            <li onClick={handleExportTechSuppliers}>
                              <span className="dropdown-item headerIcon">
                                <i className="bi bi-download mr-2"></i>
                                Download Xl
                              </span>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible5 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={suppliersColumns}
                            data={getTechnicalEvalHeaderData?.supplierList}
                            // progressPending={loading}
                            // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                            // pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Technical Evaluation 08*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible8
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility8}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">OC</span>
                      </Col>

                      <Col xs={3} md={7} lg={6}>
                        <span className="headerTitle">
                          Technical Evaluation Questions
                        </span>
                        {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-end">
                        <div className="filter">
                          <span
                            className="icon hide headerIcon"
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                          >
                            <i className="bi bi-three-dots"></i>
                          </span>
                          <ul
                            className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                            data-popper-placement="bottom-end"
                          >
                            <li className="dropdown-header text-start">
                              <h6>Menu</h6>
                            </li>

                            <li onClick={handleExportTechEvalQuestions}>
                              <span className="dropdown-item headerIcon">
                                <i className="bi bi-download mr-2"></i>
                                Download Xl
                              </span>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible8 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body autoScroll">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <EvaluationTable
                            data={techData}
                            sendDataToParent={handleEvaluationTableData}
                            pageStatus={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Line Item 09*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible9
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility9}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>

                      <Col xs={3} md={7} lg={6}>
                        <span className="headerTitle">Line Item</span>
                        {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-end">
                        <div className="filter">
                          <span
                            className="icon hide headerIcon"
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                          >
                            <i className="bi bi-three-dots"></i>
                          </span>
                          <ul
                            className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                            data-popper-placement="bottom-end"
                          >
                            <li className="dropdown-header text-start">
                              <h6>Menu</h6>
                            </li>

                            <li onClick={handleExportTechLineItems}>
                              <span className="dropdown-item headerIcon">
                                <i className="bi bi-download mr-2"></i>
                                Download Xl
                              </span>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible9 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body autoScroll">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <TechLineItemTable
                            data={lineItemData}
                            sendDataToParent={handleItemData}
                            pageStatus={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {!getDisabledStatus && (
                <div className="pageFooter">
                  <Row className="rowDirection">
                    {/* <Col xs={12} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={handleSave}
                        disabled={disabled}
                      >
                        Create Technical Evaluation
                      </button>
                    </Col> */}
                    {/* <Col xs={12} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={handleSave}
                        disabled={disabled}
                      >
                        Assign Tech Evaluator
                      </button>
                    </Col> */}
                    {/* <Col xs={12} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={handleSave}
                        disabled={disabled}
                      >
                        Save as Draft
                      </button>
                    </Col> */}
                  </Row>
                </div>
              )}

              <div className="pageFooter pb-2">
                <Row className="rowDirection">
                  {getDisabledStatus && (
                    <Col xs={12} md={3} lg={3} className="">
                      <button
                        className="btnTable"
                        onClick={handleExportTechAll}
                      >
                        <i className="bi bi-download mr-2"></i>
                        Techno Commerial Comparison
                      </button>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </Col>
        )}
      </Row>

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />
    </main>
  );
};

export default TechnicalEvaluation;
